export default __webpack_public_path__ + "static/media/Detail.e5a3669d.JPG";